export const newsArticles = [
  {
    id: 1,
    category: 'Game Recap',
    title: 'Vikings Dominate in Thrilling 34-17 Victory Over the Packers',
    excerpt: 'Justin Jefferson hauled in 3 touchdowns as the Vikings put on a dominant performance at US Bank Stadium, silencing the rival Packers in front of a sold-out crowd.',
    date: 'Apr 10, 2026',
    image: 'https://public.readdy.ai/ai/img_res/7ad2cd70df3bad08148645cab034c628.jpg',
    author: 'Mike Thompson',
  },
  {
    id: 2,
    category: 'Roster Move',
    title: 'Vikings Sign Pro Bowl Linebacker to 4-Year Extension',
    excerpt: 'The front office made a major move this week, locking up their star linebacker through the 2030 season in a deal worth $72 million, signaling the team\'s commitment to building a championship contender.',
    date: 'Apr 8, 2026',
    image: 'https://readdy.ai/api/search-image?query=Minnesota%20Vikings%20NFL%20player%20signing%20contract%20press%20conference%20purple%20jersey%20team%20logo%20background%20professional%20sports%20photography&width=600&height=400&seq=news2&orientation=landscape',
    author: 'Sarah Collins',
  },
  {
    id: 3,
    category: 'Draft Preview',
    title: '2026 NFL Draft: Top Targets for the Vikings at Pick #12',
    excerpt: 'With the 12th overall pick secured, the Vikings have several intriguing options. Our analysts break down the top prospects that could make an immediate impact on the roster this fall.',
    date: 'Apr 6, 2026',
    image: 'https://readdy.ai/api/search-image?query=NFL%20draft%20prospect%20football%20player%20college%20uniform%20running%20field%20action%20sports%20photography%20stadium%20crowd%20background&width=600&height=400&seq=news3&orientation=landscape',
    author: 'Dave Larson',
  },
  {
    id: 4,
    category: 'Fan Zone',
    title: 'Purple Pride Fan Meetup at US Bank Stadium This Weekend',
    excerpt: 'Join thousands of Vikings fans for the annual Purple Pride Fan Fest. Meet former players, get autographs, and celebrate the upcoming season with the best fan community in the NFL.',
    date: 'Apr 4, 2026',
    image: 'https://readdy.ai/api/search-image?query=Minnesota%20Vikings%20NFL%20fans%20purple%20gold%20face%20paint%20jerseys%20stadium%20crowd%20cheering%20excited%20game%20day%20atmosphere&width=600&height=400&seq=news4&orientation=landscape',
    author: 'Jessica Park',
  },
  {
    id: 5,
    category: 'Analysis',
    title: 'Breaking Down the Vikings\' New Offensive Scheme for 2026',
    excerpt: 'New offensive coordinator brings a fresh approach to the Vikings\' attack. We dive deep into the film to understand how this system will unlock the full potential of their elite skill players.',
    date: 'Apr 2, 2026',
    image: 'https://readdy.ai/api/search-image?query=NFL%20football%20coach%20whiteboard%20strategy%20playbook%20offensive%20scheme%20diagram%20professional%20sports%20coaching%20staff%20meeting&width=600&height=400&seq=news5&orientation=landscape',
    author: 'Tom Bradley',
  },
  {
    id: 6,
    category: 'History',
    title: 'Remembering the Greatest Moments in Vikings History',
    excerpt: 'From Fran Tarkenton to Randy Moss to Adrian Peterson, we take a nostalgic look back at the legendary moments that have defined the Minnesota Vikings franchise over six decades.',
    date: 'Mar 30, 2026',
    image: 'https://readdy.ai/api/search-image?query=Minnesota%20Vikings%20NFL%20vintage%20classic%20football%20game%20historic%20moment%20purple%20gold%20retro%20sports%20photography%20stadium&width=600&height=400&seq=news6&orientation=landscape',
    author: 'Robert Hayes',
  },
];
